/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

import subscriptionIllustration from '../../../assets/illustrations/subscription.svg'
import { accent, background2 } from '../../../styles/colors'
import { hFlex, overlay } from '../../../styles/style-helpers'
import background from '../../../utils/background'

export const SubscriptionUpsellEl = styled.div`
  width: calc(100vw - 2em);
  margin: 2.5em 1em;
  background: ${background2};
  padding: 1em;
  border-radius: 0.5em;

  .graphic {
    position: relative;
    padding-top: 75%;
    margin: 0 auto 1em;
    background: #fff;
    border-radius: 0.5em;

    &:after {
      content: '';
      ${overlay};
      ${background(subscriptionIllustration, 'contain')};
    }
  }

  h4 {
    margin: 1.5em 0 0.5em;
    font-weight: bold;
    color: ${accent};
  }

  p {
    margin-top: 1em;
    line-height: 1.5;
  }

  .actions {
    width: 100%;
    margin-top: 2em;
    ${hFlex};
    justify-content: flex-end;
  }
`
